import { useQuery } from "@tanstack/react-query";
import { searchRegistrations } from "../openapi/api-client.ts";

export const useSearchRegistrations = (query: string) =>
  useQuery({
    queryKey: ["registrations", "search", query],
    queryFn: async () => {
      const response = await searchRegistrations(query);

      if (!response.data) {
        throw new Error(
          `error while searching registrations: ${response.error.message}`,
        );
      }

      return response.data;
    },
    enabled: query.length >= 2,
  });
